import { Button } from '@/shared/ui/shadcn/button';

import { WizardStepSkeleton } from './_shared/WizardStepSkeleton';
import { useSubmitOnceOnMount } from './_shared/useSubmitOnceOnMount';

interface ConsumingInviteStepProps {
  submit: (payload?: unknown) => void;
  isSubmitting: boolean;
  submitError: Error | null;
}

export function ConsumingInviteStep({
  submit,
  isSubmitting,
  submitError,
}: ConsumingInviteStepProps) {
  useSubmitOnceOnMount(submit);

  if (isSubmitting) {
    return <WizardStepSkeleton />;
  }

  return submitError ? (
    <div className="flex w-full flex-col items-center gap-3 text-center">
      <p className="text-destructive text-sm">{submitError.message}</p>
      <Button type="button" variant="secondary" onClick={() => submit()}>
        Try again
      </Button>
    </div>
  ) : null;
}
